import { Font } from "@react-pdf/renderer";

Font.register({
  family: "Inter",
  fonts: [
    {
      src: "/assets/fonts/Inter_18pt-Regular.ttf",
      fontStyle: "normal",
      fontWeight: 400,
    },
    {
      src: "/assets/fonts/Inter_18pt-Italic.ttf",
      fontStyle: "italic",
      fontWeight: 400,
    },
    {
      src: "/assets/fonts/Inter_18pt-Medium.ttf",
      fontStyle: "normal",
      fontWeight: 500,
    },
    {
      src: "/assets/fonts/Inter_18pt-MediumItalic.ttf",
      fontStyle: "italic",
      fontWeight: 500,
    },
    {
      src: "/assets/fonts/Inter_18pt-SemiBold.ttf",
      fontStyle: "normal",
      fontWeight: 600,
    },
    {
      src: "/assets/fonts/Inter_18pt-SemiBoldItalic.ttf",
      fontStyle: "italic",
      fontWeight: 600,
    },
  ],
});

Font.register({
  family: "Outfit",
  fonts: [
    {
      src: "/assets/fonts/Outfit-Regular.ttf",
      fontStyle: "normal",
      fontWeight: 400,
    },
    {
      src: "/assets/fonts/Outfit-Medium.ttf",
      fontStyle: "normal",
      fontWeight: 500,
    },
    {
      src: "/assets/fonts/Outfit-SemiBold.ttf",
      fontStyle: "normal",
      fontWeight: 600,
    },
  ],
});

Font.registerHyphenationCallback((word) => [word]);
